<!-- 调查项管理界面 -->
<template>
  <div class="survey-manage-box">
    <div class="left-box">
      <div style="height: 100%;display: flex;flex-direction: column">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="margin-bottom: 20px" clearable />
        <el-tree style="overflow: auto;flex: 1;height: 0" :data="treeData" :props="defaultProps" default-expand-all
          :filter-node-method="filterNode" ref="tree" node-key="thirdDeviceId" show-checkbox />
      </div>
    </div>
    <div class="right-box access-record-container">
      <!--主页面 -->
      <div class="flex-row" style="height: 100%">
        <div class="flex-auto flex-valign" style="overflow: hidden">
          <!-- 右侧表格 -->
          <div class="section-main_table" style="flex-direction: column">
            <!-- 查询条件 -->
            <div class="query">
              <el-form style="margin-top: 10px; transition: all 200ms" :class="showSearch ? 'expand searchContent' : 'up searchContent'
                " :inline="true" ref="search-form" label-position="right" :model="searchForm">
                <el-form-item label="日期">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm.startTime"
                    :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </el-form>

              <div>
                <el-button type="primary" @click="searchResult">{{
                  $t("accountGroup.button.query")
                }}
                </el-button>
                <el-button type="primary" @click="handleExportOpt">导出
                </el-button>
                <el-button type="info" @click="resetQuery">{{
                  $t("accountGroup.button.reset")
                }}
                </el-button>
                <el-button type="text" size="medium" v-show="showExpandBtn" style="color: #407aee"
                  @click="showSearch = !showSearch" :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'
                      ">{{ !showSearch ? "展开" : "收起" }}
                </el-button>
              </div>
            </div>
            <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
              @current-change="selectPage" @size-change="changeSize">
              <template slot="menu" slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="查看图表" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="el-icon-s-data" @click="handleChartOpt(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 图表展示弹窗 -->
    <el-dialog title="查看图表" :append-to-body="true" :visible.sync="dialogChart" width="54%" class="choose-container">
      <!-- <div class="dialog-content-box">
        <div class="dialog-content-item">
          <h3 style="margin: 10px">实时用电量</h3>
          <div class="real-time-power-box">{{ todayMeter ? todayMeter : 0 }}kW·h</div>
        </div>
        <div class="dialog-content-item" style="margin: 0px 20px; flex: 2">
          <h3 style="margin: 10px">峰平谷趋势分析</h3>
          <div class="gfp-trend-box">
            <div class="gfp-trend-title-box">
              <div>kW·h</div>
              <div>峰平谷</div>
            </div>
            <div id="gfpChart" style="width: 100%; height: 12rem"></div>
          </div>
        </div>
        <div class="dialog-content-item" style="flex: 2">
          <h3 style="margin: 10px">能耗成本计算</h3>
          <div class="energy-coste">
            <div class="energy-coste-left-box">
              <div id="ecChart" style="width: 13rem; height: 10rem"></div>
            </div>
            <div class="energy-coste-right-box">
              <div class="right-item-box right-item-margin-bottom-box">
                <div class="item-first-img-circle"></div>
                <div class="item-name">峰</div>
                <div class="item-num">{{ trendAnalysis.pCost }}</div>
              </div>
              <div class="right-item-box right-item-margin-bottom-box">
                <div class="item-second-img-circle"></div>
                <div class="item-name">平</div>
                <div class="item-num">{{ trendAnalysis.fCost }}</div>
              </div>
              <div class="right-item-box">
                <div class="item-third-img-circle"></div>
                <div class="item-name">谷</div>
                <div class="item-num">{{ trendAnalysis.vCost }}</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--        <el-button type="info" @click="cancelChartChoose">取消</el-button>-->
      <!--        <el-button type="primary" @click="confirmChartChoose">确认</el-button>-->
      <!--      </span>-->
      <div class="first-row">
        <div class="first-content-item">
          <h3>实时用电量</h3>
          <div class="real-time-power">{{ todayMeter ? todayMeter : 0 }}kW·h</div>
        </div>
        <div class="second-content-item">
          <h3>能耗成本计算(元)</h3>
          <div class="content-box">
            <div class="real-time-power">
              <div class="ecChart-box">
                <div id="ecChart" style="width: 100%; height: 100%;"></div>
              </div>
            </div>
            <div class="energy-cost-box">
              <div class="data-cont">
                <div class="item-first-img-circle"></div>
                <div class="item-name">峰</div>
                <div class="item-num">{{ trendAnalysis.pCost }}</div>
              </div>
              <div class="data-cont">
                <!-- <div class="item-second-img-circle"></div> -->
                <div class="item-third-img-circle"></div>
                <div class="item-name">平</div>
                <div class="item-num">{{ trendAnalysis.fCost }}</div>
              </div>
              <div class="data-cont">
                <!-- <div class="item-third-img-circle"></div> -->
                <div class="item-second-img-circle"></div>
                <div class="item-name">谷</div>
                <div class="item-num">{{ trendAnalysis.vCost }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="second-row">
        <div class="first-content-item">
          <h3>峰平谷趋势分析</h3>
          <div class="real-time-power">
            <!-- <div class="gfp-trend-title-box">
              <div class="text">kW·h</div>
              <div class="text">峰平谷</div>
            </div> -->
            <div class="line-legend">
              <div class="legend-label-first"></div>
              <div class="legend-text">峰</div>
              <!-- <div class="legend-label-second"></div> -->
              <div class="legend-label-third"></div>
              <div class="legend-text">平</div>
              <!-- <div class="legend-label-third"></div> -->
              <div class="legend-label-second"></div>
              <div class="legend-text">谷</div>
            </div>
            <div id="gfpChart" style="width: 100%; height: 12rem"></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eCharts from "echarts";
import { api } from "../api/index";
import utils, { Dates } from "@src/common/utils";
import { tableOption } from "../config/meterIndicatorTable";
import dayjs from "dayjs";

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      defaultProps: {
        children: "children",
        label: "thirdDeviceName",
      },
      filterText: "",
      treeData: [],
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchForm: {
        startTime: dayjs().format('YYYY-MM-DD'),
      },
      showExpandBtn: false,
      showSearch: false,
      // 查看图表
      dialogChart: false,
      ecChart: null,
      ecChartOpt: null,
      gfpChart: null,
      gfpChartOpt: null,
      todayMeter: '',
      trendAnalysis: {},
    };
  },
  mounted() {
    this.getTreeData();
    this.getTableList();
    this.animation();
  },
  beforeDestroy() {
    // window.onresize = null;
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      console.log("--水电表--domAry:-", domAry);
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        console.log("--00--");
        this.showExpandBtn = true;
      } else {
        console.log("--111--");
        this.showExpandBtn = false;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.thirdDeviceName.indexOf(value) !== -1;
    },
    // 获取树数据
    getTreeData() {
      this.$fetch(api.meterIndicator.queryEnergyMeterTree).then(res => {
        if (res.success) {
          this.treeData = res.returnObj[0].children
        }
      })
    },
    // 获取右侧表格列表
    getTableList() {
      const params = {
        startTime: this.searchForm.startTime ? this.searchForm.startTime : '',
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ids: this.$refs.tree.getCheckedKeys()
      };
      this.$fetch(api.meterIndicator.getEnergyMeterDataOfDay, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.data])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        }
      );
    },

    closeDialog() {
    },

    // 查询按钮事件
    searchResult() {
      console.log("---查询--this.searchForm:--", this.searchForm);
      this.page.currentPage = 1;
      this.getTableList();
    },
    // 重置按钮
    resetQuery() {
      this.searchForm.startTime = dayjs().format('YYYY-MM-DD');
      this.$refs.tree.setCheckedKeys([])
      console.log("---重置--this.searchForm:--", this.searchForm);
      this.getTableList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getTableList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getTableList();
    },
    // 导出操作
    handleExportOpt() {
      const params = {
        startTime: this.searchForm.startTime ? this.searchForm.startTime : '',
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ids: this.$refs.tree.getCheckedKeys()
      };
      this.$fetchDownLoad(api.meterIndicator.exportMeterDataOfDay, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          const fileName =
            "水电表指标" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    // 查看图表操作
    handleChartOpt(obj) {
      console.log("--查看图表操作--");
      this.dialogChart = true;
      this.$fetch(api.meterIndicator.todayMeterConsumption + '?id=' + obj.id).then(res => {
        if (res.success) {
          this.todayMeter = res.returnObj
        }
      })
      this.$fetch(api.meterIndicator.trendAnalysisOfVfp + '?id=' + obj.id + '&dateStr=' + this.searchForm.startTime).then(res => {
        if (res.success) {
          this.trendAnalysis = res.returnObj
          this.initEnergyConstChart();
          this.initGfpTrendChart();
        }
      })
    },
    cancelChartChoose() {
      this.dialogChart = false;
    },
    confirmChartChoose() {
      this.cancelChartChoose();
    },
    initGfpTrendChart() {
      let chartDom = document.getElementById("gfpChart");
      this.gfpChart = eCharts.init(chartDom);
      // const lineColor = ['rgba(130, 107, 244, 0.7)', 'rgba(18, 206, 108, 0.7)', 'rgba(242, 75, 75, 0.7)']
      const lineColor = ['rgba(18, 206, 108, 0.7)', 'rgba(130, 107, 244, 0.7)', 'rgba(242, 75, 75, 0.7)']
      const arrLength = this.trendAnalysis.chartData.length
      const pieces = this.trendAnalysis.chartData.map((v, index) => {
        return {
          lte: index == arrLength - 1 ? null : index + 1,
          gt: index == 0 ? null : index,
          color: lineColor[v.type],
        }
      })
      this.gfpChartOpt = {
        title: {
          subtext: '(kw/h)',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          // top:'0',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // X轴底部文字颜色
          axisLabel: {
            interval: 0,//横轴信息全部显示
            rotate: -20,// -20度角倾斜显示
          }, // X轴底部文字倾斜，用于文字过多，有些字不展示的处理
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          }, // X轴网格线的颜色和solid
          data: this.trendAnalysis.chartData.map(v => v.dataTime),
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // Y轴底部文字颜色
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          }, // Y轴网格线的颜色和solid
        },
        visualMap: {
          show: false,
          dimension: 0,
          pieces: pieces
        },
        series: [
          {
            areaStyle: {},
            name: "用电量",
            type: 'line',
            smooth: true,
            data: this.trendAnalysis.chartData.map(v => v.value),
          }
        ]
      };
      this.gfpChart.setOption(this.gfpChartOpt);
    },
    initEnergyConstChart() {
      let chartDom = document.getElementById("ecChart");
      this.ecChart = eCharts.init(chartDom);
      this.ecChartOpt = {
        color: ["#F68181", "#A797F7", "#59DD98"],
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: "能耗成本计算",
            type: "pie",
            // radius: ["5rem", "200rem"],
            radius: ["10%", "100%"],
            center: ["60%", "100%"],
            // 设置角度
            startAngle: 0,
            roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              // 最重要的是下面这里
              { value: 0, itemStyle: { normal: { color: "rgba(0,0,0,0)" } } },
              { value: 0, itemStyle: { normal: { color: "rgba(0,0,0,0)" } } },
              { value: 0, itemStyle: { normal: { color: "rgba(0,0,0,0)" } } },
              { value: this.trendAnalysis.pCost, name: "峰" },
              { value: this.trendAnalysis.fCost, name: "平" },
              { value: this.trendAnalysis.vCost, name: "谷" },
            ],
          },
        ],
      };
      this.ecChart.setOption(this.ecChartOpt);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

::v-deep .el-tree-node>.el-tree-node__children {
  overflow: unset !important;
}

.expand {
  width: calc(100% - 410px);
  height: auto;
}

.up {
  width: calc(100% - 410px);
  height: 41px;
  overflow: hidden;
}

.survey-manage-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .left-box {
    width: 0px;
    flex: 1;
    height: 100%;
    padding: 20px;
    margin-right: 15px;
    @include set_theme_color(background-color, left-menu-bg-color);

    .title-box {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #fff;
      border-left-width: 3px;
      border-left-style: solid;
      padding-left: 10px;
      border-left-color: #407aee;
      position: relative;
    }

    .content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 10px;

      .content-item {
        width: 85%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #202631;
      }

      :active {
        background: #202631;
      }

      .content-selected-item {
        background: #202631;
      }

      .content-border-item {
        width: 85%;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid white;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #202631;
      }

      :active {
        background: #202631;
      }

      .content-selected-item {
        background: #202631;
      }
    }
  }

  .access-record-container {
    width: 100%;
    height: 100%;

    .el-table__fixed-right-patch {
      display: none;
    }

    .el-dialog {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
      }
    }
  }

  .right-box {
    width: 0px;
    flex: 5;
    height: 100%;

    .query {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include set_theme_color(background-color, left-menu-bg-color);
      padding: 10px 16px 3px;

      .el-form-item {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 8px !important;
        vertical-align: top;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
/* .dialog-content-box {
  height: 80vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.dialog-content-item {
  width: 0px;
  height: 100%;
  flex: 1;
  border-radius: 20px;
  border: 1px solid #797979;
}

.real-time-power-box {
  width: 10vw;
  height: 21vh;
  background: #407aee;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px auto 0px;
  font-size: x-large;
  font-weight: bold;
}

.gfp-trend-box {
  height: 21vh;
  width: 100%;
  padding: 0.5rem;
}

.gfp-trend-title-box {
  width: 100%;
  height: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.energy-coste {
  height: 21vh;
  width: 100%;
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.energy-coste-left-box {
  flex: 1.8;
  height: 100%;
}

.energy-coste-right-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 1rem 0.5rem;
}

.right-item-margin-bottom-box {
  margin-bottom: 1rem;
}

.right-item-box {
  width: 100%;
  height: 2rem;
  border-radius: 5px;
  color: #d7d7d7;
  display: flex;
  align-items: center;
}

.item-first-img-circle {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #2fc5f1;
}

.item-second-img-circle {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #d24280;
}

.item-third-img-circle {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #c0bdd7;
}

.item-name {
  font-family: "微软雅黑 Light", "微软雅黑 Regular", "微软雅黑", sans-serif;
  font-weight: 250;
  font-style: normal;
  font-size: 14px;
  color: #c9cbd0;
  margin: 0rem 1rem 0rem 0.5rem;
}

.item-num {
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: #c9cbd0;
} */

.first-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;

  .first-content-item {
    width: 100%;
    height: 300px;
    border: 1px solid #909399;
    border-radius: 10px;
    padding: 20px;

    .real-time-power {
      width: 100%;
      height: 86%;
      background: #407aee;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: x-large;
      font-weight: bold;
      margin-top: 20px;
    }
  }

  .second-content-item {
    width: 100%;
    height: 300px;
    border: 1px solid #909399;
    border-radius: 10px;
    margin-left: 20px;
    padding: 20px;

    .content-box {
      display: flex;
      width: 100%;
      height: 100%;

      .real-time-power {
        width: 70%;
        height: 86%;
        margin-top: 20px;

        .ecChart-box {
          width: 100%;
          height: 100%;
          margin-left: -50px;
          margin-top: -70px;
        }
      }

      .energy-cost-box {
        width: 30%;
        height: 86%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        .data-cont {
          display: flex;
          margin: 10px 0;
          align-items: center;
          justify-content: center;
        }

        .item-first-img-circle {
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 50%;
          background: rgba(242, 75, 75, 0.7);
        }

        .item-second-img-circle {
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 50%;
          background: rgba(18, 206, 108, 0.7);
        }

        .item-third-img-circle {
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 50%;
          background: rgba(130, 107, 244, 0.7);
        }

        .item-name {
          font-family: "微软雅黑 Light", "微软雅黑 Regular", "微软雅黑", sans-serif;
          font-weight: 600;
          font-style: normal;
          font-size: 15px;
          color: #606266;
          margin: 0rem 1rem 0rem 0.5rem;
        }

        .item-num {
          font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
          font-weight: 700;
          font-style: normal;
          font-size: 16px;
          color: #606266;
        }
      }
    }
  }
}

.second-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .first-content-item {
    width: 100%;
    height: 300px;
    border: 1px solid #909399;
    border-radius: 10px;
    padding: 20px;

    .real-time-power {
      width: 100%;
      height: 86%;
      font-size: x-large;
      font-weight: bold;

      .gfp-trend-title-box {
        width: 100%;
        height: 2rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .text {
          font-size: 14px;
        }
      }
    }
  }
}

.line-legend {
  display: flex;
  align-items: center;
  margin: 20px 0;
  justify-content: flex-end;
  font-size: 14px;

  .legend-label-first {
    width: 30px;
    height: 15px;
    background-color: rgba(242, 75, 75, 0.7);
    margin-left: 20px;
  }

  .legend-label-second {
    width: 30px;
    height: 15px;
    background-color: rgba(18, 206, 108, 0.7);
    margin-left: 20px;
  }

  .legend-label-third {
    width: 30px;
    height: 15px;
    background-color: rgba(130, 107, 244, 0.7);
    margin-left: 20px;
  }

  .legend-text {
    margin-left: 10px;
  }
}
</style>
